// How much of a module's sidebar rows a business sees (PRD 88 §4.1), for
// NavItemConfig.requiresModule and .moduleFrontDoor. Most modules are simply
// held or not; field service and personal services have a release flag and a set-up state as well,
// and cannabis a lapse state and a role list, so each answers through its own
// rule.

import type { BusinessModuleKey } from '../../types/businessApi';
import type { BusinessModulesState, ModuleNavAccess } from '../../services/businessModulesStore';
import { fieldServiceNavAccess } from '../fieldService/fieldServiceAccess';
import { cannabisNavAccess } from '../business/cannabis/cannabisAccess';
import { personalServicesNavAccess } from '../personalServices/personalServicesAccess';

export function moduleNavAccess(state: BusinessModulesState, key: BusinessModuleKey): ModuleNavAccess {
  if (key === 'field_service') return fieldServiceNavAccess(state);
  if (key === 'cannabis') return cannabisNavAccess(state);
  if (key === 'personal_services') return personalServicesNavAccess(state);
  // Unknown draws nothing (businessModulesStore).
  if (!state.modules) return 'none';
  return state.modules[key] === true ? 'all' : 'none';
}

/** The two NavItemConfig fields a module row can carry. */
export interface ModuleNavRow {
  requiresModule?: BusinessModuleKey;
  moduleFrontDoor?: BusinessModuleKey;
}

/**
 * Does this row draw for this business? A `requiresModule` row needs every
 * row of the module ('all'); a `moduleFrontDoor` row needs anything at all;
 * a row with neither is not the modules' business.
 */
export function moduleRowVisible(row: ModuleNavRow, state: BusinessModulesState): boolean {
  if (row.requiresModule) return moduleNavAccess(state, row.requiresModule) === 'all';
  if (row.moduleFrontDoor) return moduleNavAccess(state, row.moduleFrontDoor) !== 'none';
  return true;
}
